<template>
  <div
    v-if="previousElement.id"
    class="c-switch-element"
  >
    <ui-popover center>
      <template #wrapper>
        <i
          v-accessibility-focus="playPreviousElement"
          class="o-icon o-icon--previous"
          :aria-label="$t('accessibility.player.prevEpisode')"
        ></i>
      </template>
      <template #content>
        <div class="c-switch-element__content">
          <img
            :src="img"
            :alt="previousElement.title"
          >
          <p class="o-typography__title2 u-text-center u-ellipsis">
            {{ title }}
          </p>
        </div>
      </template>
    </ui-popover>
  </div>
</template>
<script>
  import UiPopover from '@/shared/components/popover/index.vue';
  import { PreviousElementMixin, PreviousEpisodeMixin, PreviousRelatedProductMixin } from '@/shared/components/player/mixins';
  import { ProductType } from '@/shared/enums';
  import meta from '@/index/shared/filters/meta';
  import { getLogo } from '@/shared/utils';

  export default {
    name: 'UiPlayerPreviousElement',
    components: { UiPopover },
    mixins: [
      PreviousElementMixin,
      PreviousEpisodeMixin,
      PreviousRelatedProductMixin,
    ],
    computed: {
      img() {
        return getLogo(this.previousElement);
      },
      title() {
        const { type, title } = this.previousElement;

        if (type === ProductType.EPISODE) {
          return `${meta(this.previousElement, 'seasonAndEpisode')}: ${title}`;
        }

        return title;
      },
    },
  };
</script>
